import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import usePageMeta from "@/hooks/usePageMeta";
import Faq from "@/components/Faq";
import { Hero } from "@/components/HeroVisuel";
import { Paquet, VideoPreuve, BandeEmail, Etapes, carteInitiale } from "@/components/CarteDuJour";
import "@/carte.css";

// Accueil en trois temps, sans rien de plus :
//   1. le concept en une phrase + le champ e-mail (le héros) ;
//   2. « L'histoire du jour » : la carte vrai/faux et sa vidéo ;
//   3. comment ça marche, une dernière invitation, la FAQ repliée. Les cartes d'avant font partie
//      du paquet (« Carte suivante »).
// Podcast, tarifs, écoles/entreprises, soutien : liens de l'en-tête et du pied de page
// (et réponses de la FAQ). Mêmes classes (carte.css, préfixe cj-) que scripts/prerendu.js.
const Landing = () => {
    usePageMeta(
        null, // titre par défaut de la marque
        "Culture générale sans effort : chaque jour, une histoire vraie, surprenante et sourcée, à lire ou écouter en 90 secondes. Gratuit, sans carte bancaire.",
    );

    // La carte du jour : le HTML pré-rendu embarque la carte du dernier build (#carte-data) pour
    // que rien ne clignote ; l'API donne ensuite celle d'aujourd'hui. ?carte=<id ou slug> montre une
    // histoire déjà publiée précise (aperçu, partage).
    const [params] = useSearchParams();
    const demandee = (params.get("carte") || "").slice(0, 120);
    const [carte, setCarte] = useState(carteInitiale);

    useEffect(() => {
        api.get("/public/carte-du-jour", { params: demandee ? { id: demandee } : {} })
            .then((r) => r.data && r.data.id && setCarte(r.data))
            .catch(() => {});
    }, [demandee]);

    return (
        <div data-testid="landing-page" className="cj">
            {/* 1. LE CONCEPT — phrase, diaporama, audio « concept en 55 s », champ e-mail */}
            <Hero />

            {/* 2. L'HISTOIRE DU JOUR — la carte + la vidéo épinglée */}
            <section id="histoire-du-jour" className="cj-w" aria-labelledby="cj-jour">
                <p id="cj-jour" className="cj-etiquette cj-lab">L&apos;histoire du jour</p>
                <div className="cj-table">
                    <Paquet key={carte.id} carte={carte} />
                    <VideoPreuve key={`v-${carte.id}`} carte={carte} />
                    <div className="cj-cote" aria-hidden="true">
                        <span className="cj-main">tu avais dit quoi&nbsp;?</span>
                    </div>
                </div>
            </section>

            {/* 3. LE RESTE, EN COURT */}
            <div className="cj-w">
                <Etapes />
                <section id="recevoir" className="cj-bas-cta" aria-labelledby="cj-recevoir-titre">
                    <h2 id="cj-recevoir-titre">Une histoire vraie par jour. 90 secondes. Des sources.</h2>
                    <BandeEmail testid="cta-bas" id="email-bas" sansPhrase />
                    {carte.total ? (
                        <p className="cj-chiffres">
                            {carte.total} histoires vraies et sourcées déjà publiées · une nouvelle chaque jour · édité par 3h33
                        </p>
                    ) : null}
                </section>
            </div>

            <Faq />
        </div>
    );
};

export default Landing;
